export const isHtmlEmpty = (html: string | undefined): boolean => {
    if (!html) return true;
    if (/data-type=/.test(html)) return false;
    return (
        html
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim().length === 0
    );
};
